import React from 'react';
import { applyTypography, BaseButton, useT } from '@repo/common';
import { ReactComponent as ArrowRightIcon } from '@repo/common/assets/icons/16px/icon_16px_arrow-right.svg';

/**
 * 취소 및 환불 상세 보기 버튼
 *
 * My bag(PaymentSummary) / Check details 에서 공용으로 사용한다.
 *
 * @param {function} onClick - 클릭 시 실행 (보통 RefundModal 오픈)
 * @param {string} className - 버튼 컨테이너 스타일 오버라이드
 * @param {string} textClassName - 라벨 스타일 오버라이드
 */
const RefundDetailsButton = ({
  onClick,
  className = '',
  textClassName = '',
}) => {
  const t = useT();

  return (
    <BaseButton
      type='text'
      size='m'
      htmlType='button'
      typo={false}
      isStatic
      leftalign
      gap='gap-0'
      iconPosition='after'
      icon={
        <ArrowRightIcon
          className='size-4 shrink-0 text-icon-secondary'
          aria-hidden='true'
        />
      }
      onClick={onClick}
      textWrapperClass={`${applyTypography(
        'b14Strong',
      )} h-auto min-w-0 flex-1 text-left text-text-primary ${textClassName}`}
      className={`h-auto w-full min-w-0 cursor-pointer items-center overflow-hidden rounded-[15px] border border-grayscale-gray02 bg-grayscale-gray00 p-4 text-left transition-opacity hover:opacity-80 tabletH:p-6 ${className}`}
    >
      {t('View cancellation & refund details', '취소 및 환불 상세 보기')}
    </BaseButton>
  );
};

export default RefundDetailsButton;
